'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POSITION_BOTTOM = exports.POSITION_TOP = exports.KEY_CODE_ESC = exports.KEY_CODE_ENTER = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = require('react-virtualized');

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SelectInput = require('./SelectInput');

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _SelectAlphabet = require('./SelectAlphabet');

var _SelectAlphabet2 = _interopRequireDefault(_SelectAlphabet);

var _SelectAutoSizer = require('./SelectAutoSizer');

var _SelectAutoSizer2 = _interopRequireDefault(_SelectAutoSizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_CODE_ENTER = exports.KEY_CODE_ENTER = 13;
var KEY_CODE_ESC = exports.KEY_CODE_ESC = 27;

var POSITION_TOP = exports.POSITION_TOP = 'top';
var POSITION_BOTTOM = exports.POSITION_BOTTOM = 'bottom';

/**
 * The popover with options, search input and alphabet.
 */

var SelectPopover = function (_PureComponent) {
    _inherits(SelectPopover, _PureComponent);

    _createClass(SelectPopover, null, [{
        key: 'renderSpinner',
        value: function renderSpinner() {
            return _react2.default.createElement(
                'div',
                { className: 'sb-selectSpinner' },
                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'spinner', size: '2XL' })
            );
        }
    }]);

    function SelectPopover(props) {
        _classCallCheck(this, SelectPopover);

        var _this = _possibleConstructorReturn(this, (SelectPopover.__proto__ || Object.getPrototypeOf(SelectPopover)).call(this, props));

        _this.handleBreakpointsSwitch = function (e) {
            return _this.setState({
                breakpointCode: e.detail.breakpoint.code
            });
        };

        _this.checkPosition = (0, _lodash.once)(function () {
            // Popover shouldn't jump from top to bottom while querying
            // So we call this function only once
            var _this$rootRef$parentN = _this.rootRef.parentNode.getBoundingClientRect(),
                parentTop = _this$rootRef$parentN.top,
                parentBottom = _this$rootRef$parentN.bottom;

            var _this$rootRef$getBoun = _this.rootRef.getBoundingClientRect(),
                height = _this$rootRef$getBoun.height;

            var windowHeight = window.innerHeight;

            // We show popover at bottom if there is enough space for it below the select button
            // or there is not enough space above the select button.
            // Otherwise it is shown at top.
            var position = windowHeight - parentBottom >= height || parentTop < height ? POSITION_BOTTOM : POSITION_TOP;

            if (position !== _this.state.position) {
                _this.setState({ position: position });
            }
        });

        _this.processListSize = function (_ref) {
            var width = _ref.width,
                height = _ref.height;
            var _this$props = _this.props,
                options = _this$props.options,
                rowHeight = _this$props.rowHeight,
                dropdownListHeight = _this$props.dropdownListHeight;
            var breakpointCode = _this.state.breakpointCode;
            var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
                NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;

            return {
                width: width,
                height: [EXTRA_NARROW, NARROW].includes(breakpointCode) ? height : Math.min(dropdownListHeight, options.length * rowHeight)
            };
        };

        _this.state = {
            didMountHandling: false,
            breakpointCode: _rpMqBreakpoints2.default.current().code,
            position: POSITION_BOTTOM
        };

        _this.renderOption = _this.renderOption.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
        _this.handleAlphabetClick = _this.handleAlphabetClick.bind(_this);
        return _this;
    }

    _createClass(SelectPopover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var onDidMount = this.props.onDidMount;

            if (onDidMount) {
                var handlerResult = onDidMount();
                if ((0, _lodash.isObject)(handlerResult) && (0, _lodash.isFunction)(handlerResult.then) && (0, _lodash.isFunction)(handlerResult.catch)) {
                    this.toggleDidMountHandling(true);
                    // TODO: handle errors
                    handlerResult.then(function () {
                        return _this2.toggleDidMountHandling(false);
                    }).catch(function () {
                        return _this2.toggleDidMountHandling(false);
                    });
                }
            }

            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            this.props.onQueryChange(e.target.value);

            /*
            * This does re-rendering of List
            * if options were changed but quantity is the same.
            *
            * For example your query is "x"
            * and you have two options "x1" and "x2".
            * After that you change query to "y"
            * and get "y1" and "y2".
            * In this case List shows previous results
            * and we should trigger update manually
            */
            if (this.listRef) {
                this.listRef.forceUpdateGrid();
            }
        }
    }, {
        key: 'handleInputKeyDown',
        value: function handleInputKeyDown(e) {
            if (e.keyCode === KEY_CODE_ENTER || e.keyCode === KEY_CODE_ESC) {
                this.props.onClose(e);
            }
        }
    }, {
        key: 'handleAlphabetClick',
        value: function handleAlphabetClick(char) {
            var _props = this.props,
                options = _props.options,
                optionLabelGetter = _props.optionLabelGetter;

            this.listRef.scrollToRow(options.findIndex(function (option) {
                return optionLabelGetter(option)[0].toLowerCase() >= char.toLowerCase();
            }));
        }
    }, {
        key: 'toggleDidMountHandling',
        value: function toggleDidMountHandling(didMountHandling) {
            this.setState({ didMountHandling: didMountHandling });
        }
    }, {
        key: 'renderAlphabet',
        value: function renderAlphabet() {
            var alphabet = this.props.alphabet;

            if (!alphabet) {
                return null;
            }

            return _react2.default.createElement(_SelectAlphabet2.default, {
                alphabet: (0, _lodash.isString)(alphabet) ? alphabet : undefined,
                onClick: this.handleAlphabetClick
            });
        }
    }, {
        key: 'renderQueryInput',
        value: function renderQueryInput() {
            var _props2 = this.props,
                query = _props2.query,
                title = _props2.title,
                showSearch = _props2.showSearch;

            if (!showSearch) {
                return null;
            }
            return _react2.default.createElement(_SelectInput2.default, {
                title: title,
                value: query,
                onChange: this.handleInputChange,
                onKeyDown: this.handleInputKeyDown
            });
        }
    }, {
        key: 'renderOption',
        value: function renderOption(_ref2) {
            var index = _ref2.index,
                key = _ref2.key,
                style = _ref2.style;

            return _react2.default.createElement(
                'div',
                {
                    key: key,
                    style: style
                },
                this.props.optionRenderer(this.props.options[index])
            );
        }
    }, {
        key: 'renderList',
        value: function renderList() {
            var _this3 = this;

            var _props3 = this.props,
                options = _props3.options,
                rowHeight = _props3.rowHeight,
                noOptionsRenderer = _props3.noOptionsRenderer;


            if (options.length === 0) {
                return noOptionsRenderer();
            }
            return _react2.default.createElement(
                'div',
                { className: 'sb-selectListWrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'sb-selectList' },
                    _react2.default.createElement(_SelectAutoSizer2.default, {
                        sizeProcessor: this.processListSize,
                        contentRenderer: function contentRenderer(_ref3) {
                            var width = _ref3.width,
                                height = _ref3.height;
                            return _react2.default.createElement(_reactVirtualized.List, {
                                ref: function ref(_ref5) {
                                    return _this3.listRef = _ref5;
                                },
                                height: height,
                                overscanRowCount: 15,
                                rowHeight: rowHeight,
                                rowCount: options.length,
                                rowRenderer: function rowRenderer(_ref4) {
                                    var index = _ref4.index,
                                        key = _ref4.key,
                                        style = _ref4.style;
                                    return _this3.renderOption({ index: index, key: key, style: style });
                                },
                                scrollToAlignment: 'start',
                                width: width
                            });
                        },
                        onDidResize: this.checkPosition
                    })
                ),
                this.renderAlphabet()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props4 = this.props,
                title = _props4.title,
                onClose = _props4.onClose;

            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(_ref6) {
                        return _this4.rootRef = _ref6;
                    },
                    className: 'ui-popover ui-popover_headless ui-popover_' + this.state.position
                },
                _react2.default.createElement('div', { className: 'ui-popoverPointer' }),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-popoverHeader' },
                    _react2.default.createElement(
                        'span',
                        { className: 'ui-popoverHeader__title' },
                        title
                    ),
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'ui-btn ui-btn_secondary ui-popoverHeader__btn',
                            onClick: onClose
                        },
                        _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Medium' })
                    )
                ),
                this.renderQueryInput(),
                this.state.didMountHandling ? SelectPopover.renderSpinner() : this.renderList()
            );
        }
    }]);

    return SelectPopover;
}(_react.PureComponent);

SelectPopover.propTypes = {
    /**
     * Title to be displayed on mobile devices
     */
    title: _react.PropTypes.string.isRequired,
    /**
     * Shows alphabet.
     * It could be boolean if you want to control the visibility of the default (English) alphabet.
     * You can also provide a string with custom chars to be rendered instead of default alphabet.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
    /**
     * Controls the visibility of search input.
     */
    showSearch: _react.PropTypes.bool,
    /**
     * Controls height of row element, defaults to 64px
     */
    rowHeight: _react.PropTypes.number,
    /**
     * Controls height of options list into dropdown (for medium and larger screens),
     */
    dropdownListHeight: _react.PropTypes.number,
    /**
     * The search query value.
     * This is the controlled component so it requires the search query value.
     */
    query: _react.PropTypes.string.isRequired,
    /**
     * Array of options to be rendered.
     */
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
    /**
     * Funtion that gets the option as an argument and returns it's label.
     * It is used to scroll to option by alphabet.
     */
    optionLabelGetter: _react.PropTypes.func.isRequired,
    /**
     * Function that gets the option as an argument and returns the React node for this option.
     */
    optionRenderer: _react.PropTypes.func.isRequired,
    /**
     * Function that renders the placeholder if no options available (due to search query or any other reason)
     */
    noOptionsRenderer: _react.PropTypes.func.isRequired,
    /**
     * This is the controlled component so it requires the search query change handler.
     */
    onQueryChange: _react.PropTypes.func.isRequired,
    /**
     * Close button 'click' handler.
     */
    onClose: _react.PropTypes.func.isRequired,
    /**
     * It could be considered as the 'open' event handler.
     * If it returns a Promise application shows the spinner until promise resolved or rejected.
     */
    onDidMount: _react.PropTypes.func
};

SelectPopover.defaultProps = {
    rowHeight: 64,
    dropdownListHeight: 354,
    query: '',
    options: []
};

exports.default = SelectPopover;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/SelectPopover.js
// module id = 1740
// module chunks = 1